import moment from 'moment';
import update from 'immutability-helper';

const NewPlanDate = (
  movingToUnscheduled,
  movingToPlan,
  dndContextSection,
  newColumn,
  draggableId,
) => {
  if (movingToUnscheduled) {
    return null;
  }

  return movingToPlan
    ? newColumn.title
    : dndContextSection.tiles[draggableId].planDate;
};

const RebuildTiles = (
  activeStatus,
  tiles,
  planDate,
  draggableId,
  leftTileId,
  rightTileId,
) => {
  const stateTiles = tiles[activeStatus].tiles;
  const movedTile = stateTiles.find(tile => tile.id.toString() === draggableId);
  const movedTileIndex = stateTiles.indexOf(movedTile);

  movedTile.planDate = planDate;
  movedTile.position = newPosition(leftTileId, rightTileId, stateTiles);
  movedTile.bucketMonth = newBucketMonth(planDate);

  stateTiles[movedTileIndex] = movedTile;
  updatePositions(stateTiles, leftTileId, rightTileId, movedTile);
  stateTiles.sort((a, b) => b.position - a.position);

  return update(tiles, {
    [activeStatus]: {
      tiles: {
        $set: stateTiles,
      },
      count: {
        $set: stateTiles.length,
      },
    },
  });
};

const newBucketMonth = planDate =>
  planDate ? moment(planDate).format('MMMM YYYY') : null;

const newPosition = (leftTileId, rightTileId, stateTiles) => {
  // order is from the biggest position to the lowest position
  if (rightTileId) {
    return (
      stateTiles.find(tile => tile.id.toString() === rightTileId).position + 1
    );
  }

  if (leftTileId) {
    return (
      stateTiles.find(tile => tile.id.toString() === leftTileId).position - 1
    );
  }
};

const updatePositions = (stateTiles, leftTileId, rightTileId, movedTile) => {
  if (!leftTileId && !rightTileId) {
    return;
  }

  stateTiles.forEach(tile => {
    if (tile.id !== movedTile.id && tile.position >= movedTile.position) {
      tile.position += 1;
    }
  });
};

export { NewPlanDate, RebuildTiles };
